import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";

import esTranslation from "./es/translation.json";
import enTranslation from "./en/translation.json";

const LANG_KEY = "em-lang";

i18n
    .use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: "es",
        supportedLngs: ["es", "en"],
        resources: {
            es: { translation: esTranslation },
            en: { translation: enTranslation },
        },
        ns: ["translation"],
        defaultNS: "translation",
        detection: {
            order: ["localStorage", "navigator", "htmlTag"],
            lookupLocalStorage: LANG_KEY,
            caches: ["localStorage"],
        },
        interpolation: {
            escapeValue: false,
        },
        returnObjects: true,
    });

export default i18n;
